export const phieuNhapKho = {
  sections: {
    list: { title: 'Phiếu nhập kho' },
    detail: { title: 'Chi tiết phiếu nhập kho' },
    lines: 'Hàng hóa nhập',
  },
  titles: { add: 'Thêm mới', addNew: 'Thêm mới' },
  columns: {
    tongSoLuong: 'Tổng số lượng',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    code: 'Mã phiếu',
    chiNhanh: 'Chi nhánh',
    loaiPhieu: 'Loại phiếu',
    ngayChungTu: 'Ngày chứng từ',
    nhaCungCap: 'Nhà cung cấp',
    khachHang: 'Khách hàng',
    chiNhanhDoi: 'Chi nhánh đối ứng',
    trangThai: 'Trạng thái',
    tongTienHang: 'Tổng tiền hàng',
    phieuTraNguon: 'Phiếu trả nguồn',
    maHoaDon: 'Mã hóa đơn',
  },
  placeholders: {
    toolbarSearch: 'Tìm kiếm',
    maLoRequired: 'Bắt buộc (hàng quản lý theo hạn)',
    maLoOptional: 'Để trống nếu không theo lô',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  fields: {
    code: 'Mã phiếu',
    chiNhanh: 'Chi nhánh',
    loaiPhieu: 'Loại phiếu',
    ngayChungTu: 'Ngày chứng từ',
    nhaCungCap: 'Nhà cung cấp',
    khachHang: 'Khách hàng',
    chiNhanhDoi: 'Chi nhánh đối ứng',
    lyDo: 'Lý do',
    ghiChu: 'Ghi chú',
    phieuChuyen: 'Phiếu chuyển',
    status: 'Trạng thái',
    totalAmount: 'Tổng tiền hàng',
    giamGiaPhieu: 'Giảm giá phiếu',
    tongSauGiamGia: 'Thành tiền',
    product: 'Hàng hóa',
    productCode: 'Mã hàng',
    productName: 'Tên hàng',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'SL sản phẩm',
    unitPrice: 'Đơn giá',
    donGiaMua: 'Đơn giá mua',
    donGiaVon: 'Đơn giá vốn',
    donViTinhMua: 'Đơn vị tính mua',
    maSp: 'Mã SP',
    tenSp: 'Tên SP',
    hinhThucVc: 'Hình thức VC',
    cont: 'Cont',
    maVanChuyenNcc: 'Mã VC NCC',
    maVanChuyenAzl: 'Mã VC AZL',
    maYcmh: 'Mã YCMH',
    maBaoGia: 'Mã báo giá',
    giamGia: 'Giảm giá',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Date sản phẩm',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Date sản phẩm',
    lineAmount: 'Thành tiền',
    lineGhiChu: 'Ghi chú dòng',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  loaiPhieu: {
    NHAP_MUA: 'Nhập mua',
    NHAP_CHUYEN: 'Nhập chuyển kho',
    NHAP_TRA_HANG: 'Nhập trả hàng',
    NHAP_DIEU_CHINH: 'Nhập điều chỉnh',
    NHAP_KHAC: 'Nhập khác',
    KIEM_KE: 'Kiểm kê',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietHang: 'Chi tiết hàng',
    lines: 'Hàng hóa nhập',
  },
  form: {
    loaiPhieu: 'Loại phiếu',
    maPhieu: 'Mã phiếu',
    maPhieuAuto: 'Tự sinh khi lưu',
    ngayChungTu: 'Ngày chứng từ',
    nhaCungCap: 'Nhà cung cấp',
    khachHang: 'Khách hàng',
    chiNhanhDoi: 'Chi nhánh đối ứng',
    lyDo: 'Lý do',
    ghiChu: 'Ghi chú phiếu',
    note: 'Ghi chú phiếu',
    sectionHeader: 'Thông tin chung',
    sectionLines: 'Hàng hóa nhập',
    sectionSummary: 'Tổng hợp',
    product: 'Hàng hóa',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'SL sản phẩm',
    unitPrice: 'Đơn giá',
    donGiaMua: 'Đơn giá mua',
    donGiaVon: 'Đơn giá vốn',
    donViTinhMua: 'Đơn vị tính mua',
    maSp: 'Mã SP',
    tenSp: 'Tên SP',
    hinhThucVc: 'Hình thức VC',
    cont: 'Cont',
    maVanChuyenNcc: 'Mã vận chuyển NCC',
    maVanChuyenAzl: 'Mã vận chuyển AZL',
    maYcmh: 'Mã YCMH',
    maBaoGia: 'Mã báo giá',
    giamGia: 'Giảm giá',
    giamGiaPhieu: 'Giảm giá phiếu',
    tongSauGiamGia: 'Thành tiền',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Date sản phẩm',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Date sản phẩm',
    lineNote: 'Ghi chú',
    lineAmount: 'Thành tiền',
    tongTienHang: 'Tổng tiền hàng',
    tongSoMatHang: 'Số mặt hàng',
    tongSoLuong: 'Tổng số lượng',
    lineCount: '{count} dòng',
    emptyAddProduct: 'Tìm và chọn hàng hóa phía trên để thêm dòng.',
    emptyAddProductPos: 'Gõ mã / tên hàng trên thanh xanh (F3) để thêm dòng.',
    save: 'Lưu',
    lotRequired: 'Bắt buộc số lô (hàng quản lý HSD)',
    expiryRequired: 'Bắt buộc hạn sử dụng (hàng quản lý HSD)',
  },
  actions: {
    complete: 'Hoàn thành',
    cancelVoucher: 'Hủy phiếu',
    copy: 'Sao chép phiếu',
    addLine: 'Thêm dòng trống',
    importExcel: 'Nhập Excel',
    downloadTemplate: 'Tải file mẫu',
    dongY: 'Đồng ý',
  },
  status: {
    phieuTam: 'Phiếu tạm',
    cho: 'Chờ',
    daHoanThanh: 'Đã nhập',
    daHuy: 'Đã hủy',
  },
  filter: {
    title: 'Lọc',
    loaiPhieu: 'Loại phiếu',
    trangThai: 'Trạng thái',
    nhaCungCap: 'NCC',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    all: 'Tất cả',
    reset: 'Đặt lại',
    sortDir: 'Thứ tự',
    asc: 'Tăng dần',
    desc: 'Giảm dần',
    advancedTitle: 'Bộ lọc chi tiết',
    nccTreeAll: 'Tất cả nhà cung cấp',
    nccTreeSearch: 'Tìm nhà cung cấp',
    nccTreeEmpty: 'Không có nhà cung cấp',
    maHangHoa: 'Mã sản phẩm',
    tenHangHoa: 'Tên sản phẩm',
  },
  messages: {
    loadError: 'Không tải được danh sách phiếu nhập kho.',
    noData: 'Chưa có phiếu nhập kho nào.',
    listSummary: 'Tổng số phiếu: {count}',
    createSuccess: 'Đã tạo phiếu nhập kho và cộng tồn.',
    updateSuccess: 'Đã cập nhật phiếu nhập kho.',
    deleteSuccess: 'Đã xóa phiếu nhập kho.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng hóa.',
    needNgayChungTu: 'Chọn ngày chứng từ trước khi lưu.',
    validateNgayChungTuBeforeNgayTao: 'Ngày chứng từ không hợp lệ.',
    needNhaCungCap: 'Chọn nhà cung cấp trước khi lưu.',
    needChiNhanhDoi: 'Chọn chi nhánh đối ứng trước khi lưu.',
    nhapTraHangBlocked:
      'Không tạo phiếu nhập trả hàng tại đây. Nhập trả chỉ tạo từ phiếu trả hàng (cần cả giá vốn và giá bán).',
    needMaSp: 'Nhập mã SP cho mọi dòng hàng.',
    needTenSp: 'Nhập tên SP cho mọi dòng hàng.',
    needSoLuong: 'Nhập số lượng sản phẩm (> 0) cho mọi dòng.',
    needDonViTinhMua: 'Nhập đơn vị tính mua cho mọi dòng hàng.',
    needMaLo: 'Nhập Serial/IMEI cho hàng {code}.',
    needHanSuDung: 'Nhập date sản phẩm cho hàng {code}.',
    giamGiaVuotDonGia: 'Giảm giá của hàng {code} không được lớn hơn đơn giá.',
    soKhongDuocAm: 'Số lượng, đơn giá, giảm giá không được âm.',
    completeSuccess: 'Đã hoàn thành phiếu nhập kho.',
    cancelVoucherSuccess: 'Đã hủy phiếu nhập kho.',
    notFound: 'Không tìm thấy phiếu.',
    noLines: 'Chưa có dòng hàng hóa.',
    loadingLines: 'Đang tải dòng hàng…',
    confirmDelete: 'Xóa phiếu {name}?',
    confirmComplete: 'Hoàn thành phiếu {name}? Tồn kho sẽ được cập nhật.',
    confirmCancelVoucher: 'Hủy phiếu {name}? Tồn kho đã cộng sẽ được trừ lại. Hành động không thể hoàn tác.',
    importDescription:
      'Tải file mẫu (cột * = bắt buộc giống nhập tay). Điền dòng hàng; chọn loại phiếu và NCC / chi nhánh đối ứng bên dưới nếu cần. Một file = một phiếu tạm.',
    importSuccess: 'Đã nhập hàng hóa từ Excel.',
    importWillCreate: 'Sẽ tạo 1 phiếu nhập kho từ {count} dòng hàng.',
    importPreviewProgress: 'Xem trước phiếu nhập',
    importPreviewLoading: 'Đang chuẩn bị phiếu nhập…',
    importPreviewDone: 'Đã tạo phiếu nhập từ xem trước.',
    importChiNhanhNhan: 'Chi nhánh nhận (đang làm việc)',
    importChiNhanhChuyen: 'Chi nhánh chuyển (đối ứng)',
    importNeedNcc: 'Nhập mua bắt buộc chọn nhà cung cấp.',
    importNeedChiNhanhDoi: 'Nhập chuyển bắt buộc chọn chi nhánh chuyển (đối ứng).',
  },
}
